export default __webpack_public_path__ + "static/media/icon-right.d4800a79.svg";